/**
 * 参考自：https://www.jianshu.com/p/3d2a8bd83191
 */
/* eslint-disable */
export default (context, width, height, dx, dy, quan, num) => {
  const size = quan * num;
  //原始图像
  let originalImgData = context.getImageData(0, 0, width, height);
  let originalPxData = originalImgData.data;

  //用于循环修改  
  let modifyImgData = context.getImageData(0, 0, width, height);
  let modifyPxData = modifyImgData.data;

  for (let i = dx - size; i < dx + size; i = i + 2 * quan + 1) {
    for (let j = dy - size; j < dy + size; j = j + 2 * quan + 1) {
      //中心点(dx,dy)
      if (!((i == dx - size && j == dy - size) || (i == dx - size && j == dy - size + 2 * quan + 1) ||
        (i == dx - size && j == dy - size + 4 * quan + 2) || (i == dx - size && j == dy - size + 12 * quan + 6) ||
        (i == dx - size && j == dy - size + 14 * quan + 7) || (i == dx - size && j == dy - size + 16 * quan + 8) ||
        (i == dx - size + 16 * quan + 8 && j == dy - size) || (i == dx - size + 16 * quan + 8 && j == dy - size + 2 * quan + 1) ||
        (i == dx - size + 16 * quan + 8 && j == dy - size + 4 * quan + 2) || (i == dx - size + 16 * quan + 8 && j == dy - size + 12 * quan + 6) ||
        (i == dx - size + 16 * quan + 8 && j == dy - size + 14 * quan + 7) || (i == dx - size + 16 * quan + 8 && j == dy - size + 16 * quan + 8) ||
        (i == dx - size + 2 * quan + 1 && j == dy - size) || (i == dx - size + 4 * quan + 2 && j == dy - size) ||
        (i == dx - size + 12 * quan + 6 && j == dy - size) || (i == dx - size + 14 * quan + 7 && j == dy - size) ||
        (i == dx - size + 2 * quan + 1 && j == dy - size + 16 * quan + 8) || (i == dx - size + 4 * quan + 2 && j == dy - size + 16 * quan + 8) ||
        (i == dx - size + 12 * quan + 6 && j == dy - size + 16 * quan + 8) || (i == dx - size + 14 * quan + 7 && j == dy - size + 16 * quan + 8))) {
        let sumR = 0;
        let sumG = 0;
        let sumB = 0;
        //找他周围的元素 
        for (let x = -quan; x <= quan; x++) {
          for (let y = -quan; y <= quan; y++) {
            let xx = i + x;
            let yy = j + y;
            let pp = yy * width + xx; //周围的元素。  
            sumR += originalPxData[pp * 4 + 0];
            sumG += originalPxData[pp * 4 + 1];
            sumB += originalPxData[pp * 4 + 2];
          }
        }

        let totlal = (2 * quan + 1) * (2 * quan + 1);
        let avgR = sumR / totlal;
        let avgG = sumG / totlal;
        let avgB = sumB / totlal;

        for (let x = -quan; x <= quan; x++) {
          for (let y = -quan; y <= quan; y++) {
            let xx = i + x;
            let yy = j + y;
            let pp = yy * width + xx; //周围的元素。  
            modifyPxData[pp * 4 + 0] = avgR;
            modifyPxData[pp * 4 + 1] = avgG;
            modifyPxData[pp * 4 + 2] = avgB;
          }
        }
      }
    }
  }
  context.putImageData(modifyImgData, 0, 0, 0, 0, width, height);
};

/* eslint-enable */


// WEBPACK FOOTER //
// ./src/utils/mosaic.js